enum NavUsersFormPage {
  INFORMATIONS = '1',
  CREDENTIALS = '2'
}

export default NavUsersFormPage;
